<template>
  <v-snackbar :color="color" :timeout="timer" v-model="showSnackbar" top centered>
    <div class="text-center">
      <v-icon v-if="icon !== ''" left> {{ icon }} </v-icon>
      <b>{{ message }}</b>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  name: "snack-bar",

  data() {
    return {
      showSnackbar: false,
      message: "",
      color: "",
      icon: "",
      timer: 2500,
    };
  },
  
  methods: {
    show(data) {
      this.message = data.message || "got no message to display.";
      this.color = data.color || "success";
      this.timer = data.timer || 2500;
      this.icon = data.icon || "";
      this.showSnackbar = true;
    },
  },
}
</script>
